var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[(!_vm.noLogin && _vm.user.authenticated)?_c('ul',{staticClass:"main-menu"},_vm._l((_vm.role_map[_vm.user.user_role]),function(item,index){return _c('li',{key:index,class:{ 'current-page': _vm.$route.path.indexOf(item.path) >= 0 }},[_c('router-link',{attrs:{"to":{name: item.to}}},[_vm._v(_vm._s(item.name))])],1)})):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b7dbf0c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = null
// module chunks = 